import { Component } from '@angular/core';

@Component({
    selector: 'home-selector',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
  })
  export class HomeComponent {

  }